import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Clone from './icon-clone.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Clone {...validProps} />;
}
SvgComponent.iconName = 'clone-icon';

export const CloneIcon = svgIconWrapper(SvgComponent);
